(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prasino-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('prasino-hero-slider')) {
    class PrasinoHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.prasino-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.prasino-hero__dot'));
        this.index = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
        this.userPaused = false;

        if (this.slides.length < 2) return;

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            this.userPaused = true;
            this.stop();
            this.goTo(i);
          });
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        this.onVisibility = () => {
          document.hidden ? this.stop() : this.start();
        };
        document.addEventListener('visibilitychange', this.onVisibility);

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.indexOf(event.target);
            if (i < 0) return;
            this.userPaused = true;
            this.stop();
            this.goTo(i);
          });
          document.addEventListener('shopify:block:deselect', (event) => {
            if (!this.contains(event.target)) return;
            this.userPaused = false;
            this.start();
          });
        }

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.userPaused) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        const interval = parseInt(this.dataset.interval, 10) || 5000;
        this.timer = setInterval(() => {
          this.goTo((this.index + 1) % this.slides.length);
        }, interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      goTo(i) {
        if (i === this.index || this.animating) return;
        const current = this.slides[this.index];
        const next = this.slides[i];

        const swap = () => {
          current.classList.remove('is-active', 'is-leaving');
          current.setAttribute('aria-hidden', 'true');
          current.setAttribute('inert', '');
          next.classList.add('is-active');
          next.removeAttribute('aria-hidden');
          next.removeAttribute('inert');

          if (this.dots.length) {
            this.dots[this.index].setAttribute('aria-current', 'false');
            this.dots[i].setAttribute('aria-current', 'true');
          }

          this.index = i;
          this.animating = false;
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          swap();
          return;
        }

        this.animating = true;
        current.classList.add('is-leaving');
        // 300ms matches the .is-leaving transition duration in the stylesheet
        setTimeout(swap, 300);
      }
    }

    customElements.define('prasino-hero-slider', PrasinoHeroSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
